export const safeHref = (url) => {
  const u = (url || "").trim();
  if (!u) return "";
  if (u.startsWith("/api/files/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return /^https?:\/\//i.test(u) ? u : "";
};
